import { useTheme } from "@opensea/next-themes"
import { useIsHydrated } from "@opensea/ui-kit/hooks"
import { useHeroHeaderView } from "@/components/hero-header/HeroHeaderViewProvider"

export function useHeroHeaderChipVariant() {
  const { resolvedTheme } = useTheme()
  const { headerView } = useHeroHeaderView()
  const isHydrated = useIsHydrated()

  return headerView === "compact" && resolvedTheme === "light" && isHydrated
    ? "default"
    : "frosted"
}
